import WxLocation from './wxLocation';
import AppLocation from './appLocation';
import WapLocation from './wapLocation';

let mockLocation = localStorage.getItem('dev_mockLocation');

const devConfig = {
    isMockLocation: localStorage.getItem('dev_isMockLocation'),
    mockLocation: mockLocation ? JSON.parse(mockLocation) : { longitude: '113.237568', latitude: '22.862375' },
};

// 接口
class Location {
    constructor(env) {
        this.proxy = this.getProxy(env);
    }

    getProxy(env) {
        console.log(env);
        if (env.isWechat) {
            return new WxLocation();
        } else if (env.isApp) {
            return new AppLocation();
        } else {
            return new WapLocation();
        }
    }

    /**
     * 获取地理位置 , 默认返回 WGS-84 坐标系经纬度
     * @return { latitude，longitude  }
     */
    getLocation(options) {
        if (devConfig.isMockLocation) {
            console.log('mock 地址');
            return Promise.resolve(devConfig.mockLocation);
        }
        return this.proxy.getLocation(options);
    }

    /**
     * 开始导航
     * options ： { latitude ，longitude ， name ， address }
     */
    openLocation(options) {
        return this.proxy.openLocation(options);
    }

    geocoderGetCity(lnglat) {
        let geocoder = new window.AMap.Geocoder();
        return new Promise((resolve, reject) => {
            geocoder.getAddress(lnglat, function(status, result) {
                console.log('status', status);
                console.log('result', result);
                if (status === 'complete' && result.info === 'OK') {
                    // result为对应的地理位置详细信息
                    let addressComponent = result.regeocode.addressComponent;
                    let city = addressComponent.city ? addressComponent.city : addressComponent.province;
                    resolve(city);
                } else {
                    reject('获取城市失败');
                }
            });
        });
    }
}

export default Location;
